<template>
  <div class="sidepanel-tv">
    <v-layout>
      <v-flex>
        <v-btn :to="'/'">  <v-icon>close</v-icon> TV-Modus beenden </v-btn>
        <simple-statistic
          :value="`
            ${duration.hours < 10 ? '0' : ''}
            ${duration.hours}:${duration.minutes < 10 ? '0' : ''}
            ${duration.minutes}:${duration.seconds < 10 ? '0' : ''}
            ${duration.seconds}
          `"
          label="Stunden ohne Störung"
          class="text-center stats"
        />
        <simple-statistic
          :value="stats.numberOfEvents"
          label="Anzahl Ereignisse"
          class="text-center stats"
        />
        <simple-statistic
          :value="stats.numberOfUnresolvedEvents"
          label="Anzahl unbehobene Ereignisse"
          class="text-center stats"
        />
        <simple-statistic
          :value="stats.numberOfResolvedEvents"
          label="Anzahl behobene Ereignisse"
          class="text-center stats"
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <p style="text-align:center; font-weight:600;">Aktuelle Störungen</p>
        <v-list two-line>
          <template v-for="(item, index) in allEvents">
            <v-list-tile
              v-if="!item.resolved"
              :key="`${JSON.stringify(item.message)}-${index}`"
              avatar
              ripple
              :class="{
                'is-unresolved': !item.resolved,
                'is-critical': item.severity === 'critical',
                'is-warning': item.severity === 'warning',
                'is-ok': item.severity === 'ok',
              }"
            >
              <v-list-tile-content>
                <v-list-tile-title>Messwert: {{ item.type }} </v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">
                  {{ item.message }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  <span v-if="item.resolved">GELÖST | </span>
                  <span v-else>UNGELÖST | </span>
                  <span v-if="item.severity === 'critical'" style="color:red;">Kritisch</span>
                  <span v-else-if="item.severity === 'warning'">Warnung</span>
                  <span v-else>OK</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-list-tile-action-text>
                  {{ $moment(item.inserted_at).format('DD.MM.YYYY HH:mm:ss') }}
                </v-list-tile-action-text>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import SimpleStatistic from './Statistics/SimpleStatistic.vue';

export default {
  name: 'TvSidePanel',
  components: {
    SimpleStatistic,
  },
  data() {
    return {
      duration: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
    };
  },
  computed: {
    stats() {
      return this.$store.state.gridAreas.stats;
    },
    allEvents() {
      return this.$store.state.gridAreas.allEvents;
    },
  },
  watch: {
    allEvents() {
      this.getDuration();
    },
  },
  mounted() {
    this.$store.dispatch('GET_ALL_EVENTS', false);
    this.$store.dispatch('GET_STATS');
  },
  methods: {
    getDuration() {
      let lastEvent = null;

      const hasCritical = this.allEvents.filter(e => !e.resolved && e.severity === 'critical').length > 0;
      if (!hasCritical) {
        const calcDuration = () => {
          this.interval = setInterval(() => {
            const now = this.$moment();
            const duration = this.$moment.duration(now.diff(lastEvent));
            this.duration.hours = parseInt(duration.asHours(), 10);
            this.duration.minutes = parseInt(duration.asMinutes(), 10) % 60;
            this.duration.seconds = parseInt(duration.asSeconds(), 10) % 60;
            return true;
          }, 1000);
        };
        lastEvent = this.$moment(this.allEvents[0].updated_at);
        clearInterval(this.interval);
        calcDuration();
      } else {
        this.duration.hours = 0;
        this.duration.minutes = 0;
        this.duration.seconds = 0;
        clearInterval(this.interval);
      }
    },
  },

};
</script>

<style scoped>
.sidepanel-tv {
    position: fixed;
    border-left: 1px solid #dfdfdf;
    top: 0;
    right: 0;
    width: 40%;
    padding: 15px;
    max-width: 25%;
    height: 100vh;
    background: #ffffff;
    z-index: 102;
    box-shadow: 10;
    transform: translateX(120%);
    transition: all 300ms;
    overflow-y: auto;
    transform: translateX(0);
}
.stats {
  padding: 10px;
  margin: 5px;
}
</style>
